(() => {
  const threshold = 5000;
  let toastTimer;

  const formatMoney = (amount, currency = 'EUR') =>
    new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency,
    }).format(amount / 100);

  const updateProgressBars = (total, currency = 'EUR') => {
    const remaining = Math.max(threshold - total, 0);
    const percentage = Math.min(Math.round((total / threshold) * 100), 100);

    document.querySelectorAll('[data-free-shipping-progress]').forEach((progress) => {
      const message = progress.querySelector('[data-free-shipping-message]');
      const fill = progress.querySelector('[data-free-shipping-fill]');
      const track = progress.querySelector('[role="progressbar"]');
      progress.dataset.total = String(total);
      progress.classList.toggle('is-complete', remaining === 0);

      if (message) {
        message.innerHTML =
          remaining > 0
            ? `Faltam <strong>${formatMoney(remaining, currency)}</strong> para teres portes grátis em Portugal`
            : '<strong>🎉 Já tens portes grátis em Portugal!</strong>';
      }
      if (fill) fill.style.width = `${percentage}%`;
      if (track) track.setAttribute('aria-valuenow', String(percentage));
    });
  };

  const showToast = (total, currency = 'EUR') => {
    const toast = document.querySelector('[data-free-shipping-toast]');
    if (!toast) return;

    const remaining = Math.max(threshold - total, 0);
    const message = toast.querySelector('[data-free-shipping-toast-message]');
    message.innerHTML =
      remaining > 0
        ? `Faltam <strong>${formatMoney(remaining, currency)}</strong> para teres portes grátis em Portugal.`
        : '<strong>🎉 Já tens portes grátis em Portugal!</strong>';

    window.clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 5000);
  };

  const fetchCartAndUpdate = (showAddedToast = false) =>
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        updateProgressBars(cart.total_price, cart.currency);
        if (showAddedToast) showToast(cart.total_price, cart.currency);
      })
      .catch(() => {
        // O carrinho mantém o conteúdo renderizado pelo Shopify.
      });

  document.addEventListener('DOMContentLoaded', () => {
    const toast = document.querySelector('[data-free-shipping-toast]');
    const close = toast?.querySelector('[data-free-shipping-toast-close]');
    close?.addEventListener('click', () => {
      window.clearTimeout(toastTimer);
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const isProductAdded = event.source === 'product-form' || event.source === 'quick-add';
        if (typeof event.cartData?.total_price === 'number' && !isProductAdded) {
          updateProgressBars(event.cartData.total_price, event.cartData.currency);
          return;
        }
        return fetchCartAndUpdate(isProductAdded);
      });
    }
  });
})();
